"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsoEffect = void 0;
var _react = require("react");
var _browser = require("../utils/browser");
// eslint-disable-next-line no-restricted-imports

const useIsoEffect = (0, _browser.isBrowser)() ? _react.useLayoutEffect : _react.useEffect;
exports.useIsoEffect = useIsoEffect;